import styled from 'styled-components';
import { header1 } from '@ardoq/typography';
import { colors } from '@ardoq/design-tokens';
import { UnstyledButton } from '@ardoq/button';

export const Title = styled.h3`
  ${header1};
  color: ${colors.green600};
  margin-top: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

/**
 * Rendered inside `Title` so the heading keeps its semantics while the
 * interactive element is a real button with native keyboard activation.
 */
export const TitleButton = styled(UnstyledButton)`
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  &:hover {
    text-decoration: underline;
  }
  &:focus-visible {
    padding: 2px;
    box-shadow: inset 0 0 0 2px ${colors.blue400};
  }
`;
